import React, { Component, ErrorInfo, ReactNode } from 'react';
import { AlertCircle } from 'lucide-react';

interface Props {
  children?: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    if (error.message.includes('dynamically imported module') || error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('error loading dynamically imported module')) {
      const reloadKey = 'app_reloaded_from_error';
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, 'true');
        window.location.reload();
      } else {
        sessionStorage.removeItem(reloadKey);
      }
    }
  }

  public render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      
      return (
        <div className="p-8 flex flex-col items-center justify-center h-full min-h-[400px] text-gray-500 text-center">
          <div className="bg-rose-50 text-rose-500 p-4 rounded-full mb-4">
            <AlertCircle size={48} />
          </div>
          <h2 className="text-2xl font-black text-slate-800 mb-2">عذراً، حدث خطأ غير متوقع</h2>
          <p className="font-bold text-slate-500 max-w-md mb-6">
            تعذر تحميل هذه الصفحة بسبب خطأ. يرجى تحديث الصفحة أو المحاولة مرة أخرى لاحقاً.
          </p>
          <button
            onClick={() => {
              this.setState({ hasError: false, error: null });
              // window.location.reload();
            }}
            className="px-6 py-3 bg-slate-900 text-white rounded-xl font-bold hover:bg-slate-800 transition-colors"
          >
            حاول مرة أخرى
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
